/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 使用者情報
 */
export interface Sgkb575aResUserInfo {
    /** 
     * 使用需要者区分：半角英数混在
     */
    usingJuyoshaDiv?: string;
    /** 
     * 使用需要者区分名称：全角半角混在
     */
    usingjyuyoshaDivaname?: string;
    /** 
     * 使用者お客さま漢字氏名：全角文字
     */
    userName?: string;
    /** 
     * 使用者お客さまカナ氏名：全角カナ
     */
    userKanaName?: string;
    /** 
     * 使用者お客さま電話番号コード１：半角英数混在
     */
    userTeldv1?: string;
    /** 
     * 使用者お客さま電話番号コード１名称：全角半角混在
     */
    userTeldv1Aname?: string;
    /** 
     * 使用者お客さま電話番号１：電話番号(ハイフンと数値含む)
     */
    userTelNo1?: string;
    /** 
     * 使用者お客さま電話番号コード２：半角英数混在
     */
    userTeldv2?: string;
    /** 
     * 使用者お客さま電話番号コード２名称：全角半角混在
     */
    userTeldv2Aname?: string;
    /** 
     * 使用者お客さま電話番号２：電話番号(ハイフンと数値含む)
     */
    userTelNo2?: string;
    /** 
     * 使用者お客さま電話番号コード３：半角英数混在
     */
    userTeldv3?: string;
    /** 
     * 使用者お客さま電話番号コード３名称：全角半角混在
     */
    userTeldv3Aname?: string;
    /** 
     * 使用者お客さま電話番号３：電話番号(ハイフンと数値含む)
     */
    userTelNo3?: string;
}
